import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { Message, MessageProps } from '../../components/Message/Message';

export function alert(
    props: Pick<MessageProps, 'title' | 'children'> & { buttonText: string }
): Promise<void> {
    const wrapper = document.body.appendChild(document.createElement('div'));
    const cleanup = (): number => {
        ReactDOM.unmountComponentAtNode(wrapper);
        return window.setTimeout(function(): void {
            return wrapper.remove();
        });
    };

    return new Promise(
        (resolve, reject): void => {
            const onClose = (): void => {
                cleanup();
                resolve();
            };
            const element = React.createElement(Message, {
                title: props.title,
                children: props.children,
                footer: React.createElement(ButtonDecorator, {
                    theme: 'pseudo',
                    view: 'default',
                    tone: 'default',
                    size: 'n',
                    onClick: onClose,
                    children: props.buttonText
                })
            });

            ReactDOM.render(element, wrapper);
        }
    );
}
